<template>
  <v-app
    light
    :style="myAppStyle"
  >
    <v-navigation-drawer
      :permanent="$mq === 'lg' || $mq === 'xl'"
      persistent
      v-model="drawer"
      enable-resize-watcher
      app
      right
      width="270"
    >
      <nav-menu :close-drawer-method="closeDrawer" />
    </v-navigation-drawer>
    <toolbar
      :profile="profile"
      :open-drawer-method="openDrawer"
      :key="$route.name + '_header'"
    />
    <v-content>
      <dine-in-timeslot v-if="mode.isDinein && Array.isArray(dineTimes)"></dine-in-timeslot>
      <v-container fluid>
        <v-layout row>
          <v-flex
            xs12
            sm12
            md12
            lg10
            offset-lg1
            xl8
            offset-xl2
          >
            <v-layout row>
                <v-flex
                  :xs7="mode.isDinein && withTableNo"
                  :xs12="!mode.isDinein || (mode.isDinein && !withTableNo)"
                >
            <span :style="myInfoStyle">
                {{ locationDisplay }}
              <span v-if="restaurants && restaurants.length > 1 && !loginByMemberToken">
                  <router-link :to="{ name: 'outlets' }">
                    <span v-if="config&&config.enable_change_restaurant" :style="routeColor">{{ $t('change') }}</span>
                  </router-link>
              </span>
              <span v-if="loginByMemberToken">
                  <router-link :to="{ name: 'area1', params: { id: 14, is_expo: true } }">
                    <span :style="routeColor">Change Store</span>
                  </router-link>
              </span>
            </span>
                </v-flex>
                <v-flex
                  v-if="mode.isDinein"
                  xs5
                  text-xs-right>
            <span
              v-if="rid"
              :style="myInfoStyle"
            >
              {{ additionalInfo }}
              <span
                v-if="allowChangeTable"
                @click="openDialog">
                <span v-if="config&&config.enable_change_table" :style="routeColor">{{ $t('change') }}</span>
              </span>
            </span>
                </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <router-view />
        <full-loading />
      </v-container>
      <restaurant-info v-if="displayRestaurantInfo" />
    </v-content>
    <feedback-message />
    <checkout-footer v-if="allowCheckout.any && getFooterType === 'checkout'" />
    <submit-footer v-else-if="allowCheckout.any && getFooterType === 'submit'" />
    <payment-footer v-else-if="getFooterType === 'payment'" />
    <confirm-footer v-else-if="getFooterType === 'confirm'" />
    <pay-bill-footer v-else-if="getFooterType === 'payment2'" />
    <menu-footer v-else-if="getFooterType === 'menu'" />
    <dining-mode-dialog />
    <setting-dialog />
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import NavMenu from '~/components/NavMenu'
import ToolBar from '~/components/ToolBar'
import FeedbackMessage from '~/components/FeedbackMessage'
import CheckoutFooter from '~/components/CheckoutFooter'
import SubmitFooter from '~/components/SubmitFooter'
import PaymentFooter from '~/components/PaymentFooter'
import ConfirmFooter from '~/components/ConfirmFooter'
import PayBillFooter from '~/components/PayBillFooter'
import MenuFooter from '~/components/MenuFooter'
import SettingDialog from '~/components/SettingDialog'
import FullLoading from '~/components/FullLoading'
import DiningModeDialog from '../components/DiningModeDialog'
import RestaurantInfo from '../components/RestaurantInfo'
import DineInTimeslot from '../components/DineInTimeslot'

export default {
  components: {
    'nav-menu': NavMenu,
    'toolbar': ToolBar,
    'feedback-message': FeedbackMessage,
    'checkout-footer': CheckoutFooter,
    'submit-footer': SubmitFooter,
    'payment-footer': PaymentFooter,
    'confirm-footer': ConfirmFooter,
    'pay-bill-footer': PayBillFooter,
    'menu-footer': MenuFooter,
    'setting-dialog': SettingDialog,
    'full-loading': FullLoading,
    'dining-mode-dialog': DiningModeDialog,
    'restaurant-info': RestaurantInfo,
    'dine-in-timeslot': DineInTimeslot
  },
  data: () => ({
    profile: false,
    drawer: false
  }),
  computed: {
    ...mapGetters('config', [
      'theme', 'allowCheckout', 'withTableNo', 'tbdata', 'restaurants',
      'rid', 'config', 'mode', 'modes', 'allPaymentModesLength', 'socialUrl',
      'logo', 'logoDark'
    ]),
    ...mapGetters('member', [
      'isMember'
    ]),
    ...mapGetters('cart', [
      'cartQty', 'times', 'pickupTime'
    ]),
    ...mapGetters('order', [
      'activeOrder', 'activeBill', 'paymentMode', 'activeOrderPayments'
    ]),
    ...mapGetters('auth', [
      'loginByMemberToken'
    ]),
    ...mapGetters('dine_mode', [
      'dineTimes',
    ]),
    myAppStyle () {
      return {
        backgroundColor: this.theme.bg_color
      }
    },
    myInfoStyle () {
      return {
        color: this.theme.title_color,
        fontSize: '13px'
      }
    },
    additionalInfo () {
      let info = ''
      if (this.mode.isDinein) {
        if (this.withTableNo) {
          if (this.tbdata) {
            if (parseInt(this.tbdata.IsTakeaway) === 1) {
              info = 'Take Away'
            } else {
              info = this.$t('table') + ': ' + this.tbdata.Name
            }
          } else {
            info = this.$t('no_table')
          }
        }
      }
      return info
    },
    locationDisplay () {
      return this.rid ? this.config.location : 'No outlet'
    },
    routeColor () {
      return {
        color: this.theme.app_chg_color
      }
    },
    allowChangeTable () {
      return this.withTableNo && this.mode.isDinein
    },
    displayRestaurantInfo () {
      return this.$route.name === 'menu' && (this.config.seo_description || (this.socialUrl.facebook || this.socialUrl.instagram || this.socialUrl.telegram))
    },
    getFooterType () {
      switch (this.$route.name) {
        case 'menu':
        case 'home':
        case 'welcome':
          if (this.cartQty > 0) {
            return 'cart'
          }
          return null

        case 'cart':
          if (this.cartQty > 0) {
            return 'checkout'
          }
          return 'menu'

        case 'checkout':
          if (this.activeOrder) {
            if (parseFloat(this.activeOrderPayments.topay_payment) === 0) return 'confirm'
            // pay before serve: paymentMode === 0, pay after serve: paymentMode === 1
            // allPaymentModesLength: count of restaurant allowed payment modes, paynow(no payment), cybersource, 2c2p ...
            // (pay before serve and not payment modes) or pay after serve
            if (((this.mode.paymentMode === 0 && this.allPaymentModesLength === 0) || this.mode.paymentMode === 1 || (this.paymentMode && this.paymentMode.code === 'pay_at_counter'))) {
              return 'submit'
              // return this.mode.paymentMode === 0 && parseFloat(this.activeOrderPayments.topay_payment) > 0 ? 'payment' : 'submit'
            } else if (this.paymentMode) {
              return this.paymentMode.payType === 'payment' ? 'payment' : 'submit'
            }
          }
          return null

        case 'bill':
          if (this.activeBill && this.paymentMode) {
            return 'payment2'
          }
          return null

        case 'orders':
        case 'order':
        case 'order2':
          if (this.cartQty > 0) {
            return 'cart'
          }
          return null
        default:
          return null
      }
    }
  },
  methods: {
    openDrawer () {
      this.drawer = true
    },
    closeDrawer () {
      this.drawer = false
    },
    openDialog () {
      this.$store.dispatch('dialog/showSettingDialog', 'table')
    }
  },
  mounted () {
    // const link = document.querySelector("[rel='icon']")
    //
    // link.setAttribute('href', this.logoDark ? this.logoDark : window.config.sharedPictures + 'logo.png')
    this.$bus.$emit('refreshFontName', this.theme.font)
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/app.vue